export function buildPlanningEpisodeAddendumPayload(attachment) {
  return {
    fileId: attachment.fileId,
    contentId: attachment.contentId,
    episodeIds: attachment.episodeIds,
    receivedAt: attachment.receivedAt,
  };
}

export function buildPlanningChapterAddendumPayload(attachment) {
  return {
    fileId: attachment.fileId,
    contentId: attachment.contentId,
    chapterIds: attachment.chapterIds || attachment.episodeIds,
    receivedAt: attachment.receivedAt,
  };
}

export function buildEditChapterAddendumPayload(attachment) {
  return {
    chapterIds: attachment.chapterIds,
    received: attachment.receivedAt,
  };
}

export function buildEditEpisodeAddendumPayload(attachment) {
  return {
    episodeIds: attachment.episodeIds,
    received: attachment.receivedAt,
  };
}

export function buildChapterAddendumAssociationsPayload(addendumIds) {
  return {
    addendumIds,
  };
}

export function buildEpisodeAddendumAssociationsPayload(addendumIds) {
  return {
    addendumIds,
  };
}
